import { cva } from 'class-variance-authority';
import { cn } from '@r/utils/utils.ts';

const helpVariants = cva(
  'mt-1 font-light peer-disabled:cursor-not-allowed peer-disabled:opacity-30',
  {
    variants: {
      variant: {
        default: 'text-foreground',
        error: 'text-red-500'
      },
      helpSize: {
        default: 'text-sm pl-[0.125rem]',
        sm: 'text-xs pl-[0.063]',
        md: 'text-sm pl-[0.125rem]',
        lg: 'text-lg pl-[0.188rem]'
      }
    },
    defaultVariants: {
      variant: 'default',
      helpSize: 'default'
    }
  }
);

interface HelpMessageProps {
  className?: string;
  error?: boolean;
  help?: string;
  variant?: 'default' | 'error';
  helpSize?: 'default' | 'sm' | 'md' | 'lg';
}

function Help({ className, error = false, help = '', variant, helpSize }: HelpMessageProps) {
  variant = error ? 'error' : variant;

  return <p className={cn(helpVariants({ variant, helpSize, className }))}>{help}</p>;
}

export { Help };
